import { CMLEditorNaptime as CMLEditor } from 'bundles/cml';

export type { CMLEditorNaptimeProps as Props } from 'bundles/cml';

export default CMLEditor;
